import React from 'react'

import { withRouter } from 'react-router-dom'

import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Dialog } from 'primereact/dialog'
import { Dropdown } from 'primereact/dropdown'
import { OverlayPanel } from 'primereact/overlaypanel';
import { InputText } from 'primereact/inputtext'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import NavBar from '../../componentes/Navbar'

import PessoaService from '../../app/service/PessoaService'
import LocalStorageService from '../../app/service/localStorageService'
import GrupoPessoasUsuariosService from '../../app/service/GrupoPessoasUsuariosService'
import EstadoService from '../../app/service/EstadoService'
import CidadeService from '../../app/service/CidadeService'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import './pessoa.css'

class Pessoas extends React.Component {
  constructor(props) {
    super(props);

    this.pessoaService = new PessoaService();
    this.grupoPessoasUsuariosService = new GrupoPessoasUsuariosService();
    this.estadoService = new EstadoService();
    this.cidadeService = new CidadeService();

    this.onChangeEstado = this.onChangeEstado.bind(this);
    this.onChangeCidade = this.onChangeCidade.bind(this);
    this.onChangeGrupo = this.onChangeGrupo.bind(this);
    this.acoes = this.acoes.bind(this);
    this.accept = this.accept.bind(this);
    this.renderFooterDocumentos = this.renderFooterDocumentos.bind(this);

    this.state = {
      pessoa: null,
      clientes: [],
      nome: null,
      cpfCnpj: null,
      cidade: null,
      telefone: null,
      empresa: null,
      porLetra: null,
      letra: null,
      grupo: null,
      usuario: null,
      detail: '',
      grupos: [],
      estados: [],
      estado: null,
      cidades: [],
      consultaNome: null,
      visible: false,
      letraA: 'letraNaoMarcada', //Desmarcado
      letraB: 'letraNaoMarcada', //Desmarcado
      letraC: 'letraNaoMarcada', //Desmarcado
      letraD: 'letraNaoMarcada', //Desmarcado
      letraE: 'letraNaoMarcada', //Desmarcado
      letraF: 'letraNaoMarcada', //Desmarcado
      letraG: 'letraNaoMarcada', //Desmarcado
      letraH: 'letraNaoMarcada', //Desmarcado
      letraI: 'letraNaoMarcada', //Desmarcado
      letraJ: 'letraNaoMarcada', //Desmarcado
      letraK: 'letraNaoMarcada', //Desmarcado
      letraL: 'letraNaoMarcada', //Desmarcado
      letraM: 'letraNaoMarcada', //Desmarcado
      letraN: 'letraNaoMarcada', //Desmarcado
      letraO: 'letraNaoMarcada', //Desmarcado
      letraP: 'letraNaoMarcada', //Desmarcado
      letraQ: 'letraNaoMarcada', //Desmarcado
      letraR: 'letraNaoMarcada', //Desmarcado
      letraS: 'letraNaoMarcada', //Desmarcado
      letraT: 'letraNaoMarcada', //Desmarcado
      letraA: 'letraNaoMarcada', //Desmarcado
      letraU: 'letraNaoMarcada', //Desmarcado
      letraV: 'letraNaoMarcada', //Desmarcado
      letraX: 'letraNaoMarcada', //Desmarcado
      letraZ: 'letraNaoMarcada', //Desmarcado
      letraY: 'letraNaoMarcada', //Desmarcado
      letraW: 'letraNaoMarcada', //Desmarcado
      letraCheck: '',
      openSpinner: false,
      //linkContratoPrestacaoServico: '',
      //Documentos
      documeno: null,
      modalDocumentos: null,
    };
  }

  abrirModalDocumentos(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  renderFooterDocumentos(name) {
    return (
        <div className="right">
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  documentoContratoPrestacaoServico = () => {
    if(this.state.pessoa.nacionalidade == null || this.state.pessoa.nacionalidade == "") {
      this.toast.show({severity:'error', summary: 'Contrato de Prestação de Serviço', detail:'O documento não pode ser exibido, faltanto Nacionalidade do cliente', life: 8000});
      return;
    }
    
    if(this.state.pessoa.estadoCivil == null) {
      this.toast.show({severity:'error', summary: 'Contrato de Prestação de Serviço', detail:'O documento não pode ser exibido, faltanto Estado Civil do cliente', life: 8000});
      return;
    }

    if(this.state.pessoa.profissao == null || this.state.pessoa.profissao == "") {
      this.toast.show({severity:'error', summary: 'Contrato de Prestação de Serviço', detail:'O documento não pode ser exibido, faltanto Profissão do cliente', life: 8000});
      return;
    }

    if(this.state.pessoa.rg == null || this.state.pessoa.rg == "") {
      this.toast.show({severity:'error', summary: 'Contrato de Prestação de Serviço', detail:'O documento não pode ser exibido, faltanto Número de Identidade do cliente', life: 8000});
      return;
    }

    if(this.state.pessoa.cpfCnpj == null || this.state.pessoa.cpfCnpj == "") {
      this.toast.show({severity:'error', summary: 'Contrato de Prestação de Serviço', detail:'O documento não pode ser exibido, faltanto Número de CPF do cliente', life: 8000});
      return;
    }

    if(this.state.pessoa.endereco == null || this.state.pessoa.endereco == "") {
      this.toast.show({severity:'error', summary: 'Contrato de Prestação de Serviço', detail:'O documento não pode ser exibido, faltanto Endereço do cliente', life: 8000});
      return;
    }

    if(this.state.pessoa.bairro == null || this.state.pessoa.bairro == "") {
      this.toast.show({severity:'error', summary: 'Contrato de Prestação de Serviço', detail:'O documento não pode ser exibido, faltanto Bairro do cliente', life: 8000});
      return;
    }

    if(this.state.pessoa.cidade == null) {
      this.toast.show({severity:'error', summary: 'Contrato de Prestação de Serviço', detail:'O documento não pode ser exibido, faltanto Cidade do cliente', life: 8000});
      return;
    }

    if(this.state.pessoa.cep == null || this.state.pessoa.cep == "") {
      this.toast.show({severity:'error', summary: 'Contrato de Prestação de Serviço', detail:'O documento não pode ser exibido, faltanto Cep do Endereço do cliente', life: 8000});
      return;
    }

    this.setState({linkContratoPrestacaoServico: `#/contratoPrestacaoServico/${this.state.pessoa.nome}/${this.state.pessoa.nacionalidade}/${this.state.pessoa.estadoCivil.nome}/${this.state.pessoa.profissao}/${this.state.pessoa.rg}/${this.state.pessoa.cpfCnpj}/${this.state.pessoa.endereco}/${this.state.pessoa.numero}/${this.state.pessoa.bairro}/${this.state.pessoa.cidade.nome}/${this.state.pessoa.cidade.estado.estado}/${this.state.pessoa.cep}`});  
  }

  documentoProcuracaoAdJudicia = () => {
    if(this.state.pessoa.nacionalidade == null) {
      this.toast.show({severity:'error', summary: 'Contrato de Prestação de Serviço', detail:'O documento não pode ser exibido, faltanto Nacionalidade do cliente', life: 8000});
      return;
    }
    
    if(this.state.pessoa.estadoCivil == null) {
      this.toast.show({severity:'error', summary: 'Contrato de Prestação de Serviço', detail:'O documento não pode ser exibido, faltanto Estado Civil do cliente', life: 8000});
      return;
    }

    if(this.state.pessoa.profissao == null) {
      this.toast.show({severity:'error', summary: 'Contrato de Prestação de Serviço', detail:'O documento não pode ser exibido, faltanto Profissão do cliente', life: 8000});
      return;
    }

    if(this.state.pessoa.rg == null) {
      this.toast.show({severity:'error', summary: 'Contrato de Prestação de Serviço', detail:'O documento não pode ser exibido, faltanto Número de Identidade do cliente', life: 8000});
      return;
    }

    if(this.state.pessoa.cpfCnpj == null) {
      this.toast.show({severity:'error', summary: 'Contrato de Prestação de Serviço', detail:'O documento não pode ser exibido, faltanto Número de CPF do cliente', life: 8000});
      return;
    }

    if(this.state.pessoa.endereco == null) {
      this.toast.show({severity:'error', summary: 'Contrato de Prestação de Serviço', detail:'O documento não pode ser exibido, faltanto Endereço do cliente', life: 8000});
      return;
    }

    if(this.state.pessoa.bairro == null) {
      this.toast.show({severity:'error', summary: 'Contrato de Prestação de Serviço', detail:'O documento não pode ser exibido, faltanto Bairro do cliente', life: 8000});
      return;
    }

    if(this.state.pessoa.cidade == null) {
      this.toast.show({severity:'error', summary: 'Contrato de Prestação de Serviço', detail:'O documento não pode ser exibido, faltanto Cidade do cliente', life: 8000});
      return;
    }

    if(this.state.pessoa.cidade == null) {
      this.toast.show({severity:'error', summary: 'Contrato de Prestação de Serviço', detail:'O documento não pode ser exibido, faltanto Cep do Endereço do cliente', life: 8000});
      return;
    }

    this.setState({linkDocumentoProcuracaoAdJudicia: `#/procuracaoAdJudicia/${this.state.pessoa.nome}/${this.state.pessoa.nacionalidade}/${this.state.pessoa.estadoCivil.nome}/${this.state.pessoa.profissao}/${this.state.pessoa.rg}/${this.state.pessoa.cpfCnpj}/${this.state.pessoa.endereco}/${this.state.pessoa.numero}/${this.state.pessoa.bairro}/${this.state.pessoa.cidade.nome}/${this.state.pessoa.cidade.estado.estado}/${this.state.pessoa.cep}`});  
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  carregarCombos = () => {
    this.limparCamposConsulta();
    this.listarGruposUsuario();
    this.listarEstados();
  }

  listarGruposUsuario = async() => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.grupoPessoasUsuariosService.listarGruposConsulta(usuarioLogado.codigo)
      .then(response => {
        this.setState({grupos: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Grupo de Pessoas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarEstados = async() => {
    await this.estadoService.listarEstados()
      .then(response => {
        this.setState({estados: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Estados', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarCidades = async(estado) => {
    await this.cidadeService.listarCidades(estado)
      .then(response => {
        this.setState({cidades: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Cidades', detail:`${this.state.detail}`, life: 4000});
      })
  }
  async onChangeEstado(e) {
    if(e.value != null) {
      this.setState({ estado: e.value });
      this.setState({openSpinner: true});
      await this.listarCidades(e.value.codigo);
      this.setState({openSpinner: false});
    } else {
      this.setState({estado: null});
      this.setState({cidades: []});
    }
  }

  onChangeCidade(e) {
    this.setState({ cidade: e.value });
  }

  onChangeGrupo(e) {
    this.setState({grupo: e.value});
  }

  consultarPessoas = async() => {
    const usuarioLogado = this.context.usuarioAutenticado;
    var estado = null;
    var cidade = null;
    var grupo = null;

    if(this.state.estado != null) {
      estado = this.state.estado.codigo;
    }

    if(this.state.cidade != null) {
      cidade = this.state.cidade.codigo;
    }

    if(this.state.grupo != null) {
      grupo = this.state.grupo.codigo;
    }

    const filtro = {
      nome: this.state.nome,
      cpfCnpj: this.state.cpfCnpj,
      estado: estado,
      cidade: cidade,
      telefone: this.state.telefone,
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo,
      porLetra: this.state.porLetra,
      letra: this.state.letra,
      grupo: grupo
    }

    this.setState({openSpinner: true});
    await this.pessoaService.consultarPessoas(filtro)
      .then(response => {
        this.setState({clientes: response.data});
        LocalStorageService.adicionarConsulta('_consulta_pessoa_filtro', filtro);
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Pessoas', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({openSpinner: false});
      this.op.hide();
  }

  componentDidMount() {
    const consultaFiltro = LocalStorageService.obterConsulta('_consulta_pessoa_filtro');
    const consultaFiltroJson = JSON.parse(consultaFiltro);

    if(consultaFiltroJson != null) {
      this.pessoaService.consultarPessoas(consultaFiltroJson)
        .then(response => {
          this.setState({clientes: response.data});
        }).catch(error => {
          this.setState(error.response.data)
          this.toast.show({severity:'error', summary: 'Pessoas', detail:`${this.state.detail}`, life: 4000});
        })
    }
  }

  adicionarPessoa = () => {
    this.props.history.push('cadastrarPessoa');
  }

  limparCamposConsulta = () => {
    this.setState({ cpfCnpj: null });
    this.setState({cidade: null});
    this.setState({telefone: null});
    this.setState({porLetra: null});
    this.setState({letra: null});
    this.setState({grupo: null});
    this.setState({nome: null});
    this.setState({letraCheck: ''});
    this.setState({letraA: 'letraNaoMarcada'})
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  consultaRapida = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.setState({cpfCnpj: null});
    this.setState({cidade: null});
    this.setState({telefone: null});
    this.setState({porLetra: null});
    this.setState({letra: null});
    this.setState({grupo: null});
    this.setState({nome: null});
    this.setState({letraCheck: null});
    this.setState({letraA: 'letraNaoMarcada'})
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})

    const filtro = {
      nome: this.state.consultaNome,
      cpfCnpj: this.state.cpfCnpj,
      cidade: this.state.cidade,
      telefone: this.state.telefone,
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo,
      porLetra: this.state.porLetra,
      letra: this.state.letra,
      grupo: this.state.grupo
    }
    this.setState({openSpinner: true});
    await this.pessoaService.consultarPessoas(filtro)
      .then(response => {
        this.setState({clientes: response.data});
        LocalStorageService.adicionarConsulta('_consulta_pessoa_filtro', filtro);
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Pessoas', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({openSpinner: false});
  }

  onA = async () => {
    await this.setState({letraCheck: 'A'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'A'});
    this.consultarPessoas();
    this.setState({letraA: 'letraMarcada'})
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onB = async () => {
    await this.setState({letraCheck: 'B'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'B'});
    this.consultarPessoas();
    this.setState({letraA: 'letraNaoMarcada'})
    this.setState({letraB: 'letraMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onC = async () => {
    await this.setState({letraCheck: 'C'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'C'});
    this.consultarPessoas();
    this.setState({letraA: 'letraNaoMarcada'})
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onD = async () => {
    await this.setState({letraCheck: 'D'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'D'});
    this.consultarPessoas();
    this.setState({letraA: 'letraNaoMarcada'})
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onE = async () => {
    await this.setState({letraCheck: 'E'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'E'});
    this.consultarPessoas();
    this.setState({letraA: 'letraNaoMarcada'})
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onF = async () => {
    await this.setState({letraCheck: 'F'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'F'});
    this.consultarPessoas();
    this.setState({letraA: 'letraNaoMarcada'})
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onG= async () => {
    await this.setState({letraCheck: 'G'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'G'});
    this.consultarPessoas();
    this.setState({letraA: 'letraNaoMarcada'})
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onH= async () => {
    await this.setState({letraCheck: 'H'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'H'});
    this.consultarPessoas();
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onI= async () => {
    await this.setState({letraCheck: 'I'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'I'});
    this.consultarPessoas();
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onJ= async () => {
    await this.setState({letraCheck: 'J'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'J'});
    this.consultarPessoas();
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onK= async () => {
    await this.limparCamposConsulta();
    this.setState({ letraCheck: 'K' });
    this.setState({porLetra: 'S'});
    this.setState({letra: 'K'});
    this.consultarPessoas();
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onL= async () => {
    await this.setState({letraCheck: 'L'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'L'});
    this.consultarPessoas();
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onM= async () => {
    await this.setState({letraCheck: 'M'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'M'});
    this.consultarPessoas();
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onN= async () => {
    await this.setState({letraCheck: 'N'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'N'});
    this.consultarPessoas();
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onO= async () => {
    await this.setState({letraCheck: 'O'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'O'});
    this.consultarPessoas();
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onP= async () => {
    await this.setState({letraCheck: 'P'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'P'});
    this.consultarPessoas();
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onQ= async () => {
    await this.setState({letraCheck: 'Q'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'Q'});
    this.consultarPessoas();
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onR= async () => {
    await this.setState({letraCheck: 'R'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'R'});
    this.consultarPessoas();
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }
  onS= async () => {
    await this.setState({letraCheck: 'S'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'S'});
    this.consultarPessoas();
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onT= async () => {
    await this.setState({letraCheck: 'T'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'T'});
    this.consultarPessoas();
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onU= async () => {
    await this.setState({letraCheck: 'U'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'U'});
    this.consultarPessoas();
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onV= async () => {
    await this.setState({letraCheck: 'V'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'V'});
    this.consultarPessoas();
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onX= async () => {
    await this.setState({letraCheck: 'X'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'X'});
    this.consultarPessoas();
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onZ= async () => {
    await this.setState({letraCheck: 'Z'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'Z'});
    this.consultarPessoas();
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onY= async () => {
    await this.setState({letraCheck: 'Y'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'Y'});
    this.consultarPessoas();
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraMarcada'})
    this.setState({letraW: 'letraNaoMarcada'})
  }

  onW = async () => {
    await this.setState({letraCheck: 'W'});
    this.setState({porLetra: 'S'});
    this.setState({letra: 'W'});
    this.consultarPessoas();
    this.setState({letraB: 'letraNaoMarcada'})
    this.setState({letraC: 'letraNaoMarcada'})
    this.setState({letraD: 'letraNaoMarcada'})
    this.setState({letraE: 'letraNaoMarcada'})
    this.setState({letraF: 'letraNaoMarcada'})
    this.setState({letraG: 'letraNaoMarcada'})
    this.setState({letraH: 'letraNaoMarcada'})
    this.setState({letraI: 'letraNaoMarcada'})
    this.setState({letraJ: 'letraNaoMarcada'})
    this.setState({letraK: 'letraNaoMarcada'})
    this.setState({letraL: 'letraNaoMarcada'})
    this.setState({letraM: 'letraNaoMarcada'})
    this.setState({letraN: 'letraNaoMarcada'})
    this.setState({letraO: 'letraNaoMarcada'})
    this.setState({letraP: 'letraNaoMarcada'})
    this.setState({letraQ: 'letraNaoMarcada'})
    this.setState({letraR: 'letraNaoMarcada'})
    this.setState({letraS: 'letraNaoMarcada'})
    this.setState({letraT: 'letraNaoMarcada'})
    this.setState({letraU: 'letraNaoMarcada'})
    this.setState({letraV: 'letraNaoMarcada'})
    this.setState({letraX: 'letraNaoMarcada'})
    this.setState({letraZ: 'letraNaoMarcada'})
    this.setState({letraY: 'letraNaoMarcada'})
    this.setState({letraW: 'letraMarcada'})
  }

  acoes(rowData) {
    var exibirDocumentos = 'none';
    const usuarioLogado = this.context.usuarioAutenticado;
    if(usuarioLogado.empresa.codigo == 60) {
      exibirDocumentos = 'hide';
    } else {
      exibirDocumentos = 'none';
    }
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                tooltip="Editar"
                onClick={() => this.editarPessoa(rowData)} 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-book" className="p-button-rounded p-button-text" 
                tooltip="Documentos"
                onClick={() => this.consultarPessoaDocumento(rowData)} 
                tooltipOptions={{position: 'top'}} 
                style={{display: `${exibirDocumentos}`}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusao(rowData)} 
                tooltip="Excluir Pessoa" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  accept() {
    this.excluirPessoa();
  }

  confirmaExclusao(pessoa) {
      this.setState({codigo: pessoa.codigo});
      confirmDialog({
          message: 'Deseja realmente excluir a pessoa selecionada ?',
          header: 'Exclusão de pessoa',
          icon: 'pi pi-info-circle',
          acceptClassName: 'p-button-danger',
          acceptLabel: 'Sim',
          rejectLabel: 'Não',
          accept: this.accept,
          reject: this.reject
      });
  }

  excluirPessoa = async () => {
    await this.pessoaService.excluirPessoa(this.state.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Pessoas', detail:'Pessoa excluída com sucesso', life: 4000});
        //Resgatando consulta do storage
        const consultaFiltro = LocalStorageService.obterConsulta('_consulta_pessoa_filtro');
        const consultaFiltroJson = JSON.parse(consultaFiltro);
        this.pessoaService.consultarPessoas(consultaFiltroJson)
          .then(response => {
            this.setState({clientes: response.data});
          }).catch(error => {
            this.setState(error.response.data)
            this.toast.show({severity:'error', summary: 'Pessoas', detail:`${this.state.detail}`, life: 4000});
          })
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Pessoas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async editarPessoa(pessoa) {
    this.props.history.push(`/consultarPessoas/${pessoa.codigo}`);
  }

  async consultarPessoaDocumento(pessoa) {
    this.setState({openSpinner: true});
    await this.pessoaService.consultarPessoa(pessoa.codigo)
      .then(response => {
        this.setState({pessoa: response.data});
        this.abrirModalDocumentos('modalDocumentos');
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Pessoas', detail:'Erro ao consultar pessoas', life: 4000});
      });
      this.setState({openSpinner: false});
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="fas fa-user-tie"></i>
                        <span> Pessoas</span>
                      </h3>  
                    </div>

                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-5">
                          <span className="input-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                      onClick={this.adicionarPessoa} 
                                      aria-haspopup aria-controls="overlay_panel">
                              <i className="fas fa-plus"></i> Adicionar</button>

                              &nbsp;
                              <button type="button" className="btn btn-info bg-gradient-info" 
                                      data-toggle="modal" 
                                      title="Filtro Avançado"
                                      onClick={(e) => this.op.toggle(e)} 
                                      aria-haspopup aria-controls="overlay_panel">
                              <i className="fas fa-filter"></i></button>

                              <OverlayPanel ref={(el) => this.op = el} showCloseIcon id="overlay_panel" 
                                            style={{width: '750px'}} 
                                            className="overlaypanel-demo"
                                            onShow={this.carregarCombos}>

                                <div className="row">
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <label>Nome</label>
                                      <InputText id="nome" 
                                                type="text" 
                                                style={{width: '100%'}} 
                                                value={this.state.nome}
                                                onChange={e => this.setState({nome: e.target.value})}
                                                className="p-inputtext-sm p-d-block p-mb-1"/>
                                    </div>
                                  </div>
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <label>Cpf/Cnpj</label>
                                      <InputText id="cpfcnpj" 
                                                type="text" 
                                                style={{width: '100%'}} 
                                                value={this.state.cpfCnpj}
                                                onChange={e => this.setState({cpfCnpj: e.target.value})}
                                                className="p-inputtext-sm p-d-block p-mb-1"/>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <label>Estado</label>
                                      <Dropdown value={this.state.estado}
                                                options={this.state.estados}
                                                optionLabel="estado"
                                                filter showClear filterBy="estado"
                                                style={{width: '100%'}} 
                                                onChange={this.onChangeEstado}
                                                id="estado"
                                                className="p-inputtext-sm p-d-block p-mb-1"/>
                                    </div>
                                  </div>
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <label>Cidade</label>
                                      <Dropdown value={this.state.cidade}
                                                options={this.state.cidades}
                                                optionLabel="nome"
                                                filter showClear filterBy="nome"
                                                style={{width: '100%'}} 
                                                emptyMessage=" "
                                                onChange={this.onChangeCidade}
                                                id="cidade"
                                                className="p-inputtext-sm p-d-block p-mb-1"/>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <label>Grupo de Pessoas</label>
                                      <Dropdown value={this.state.grupo} 
                                          options={this.state.grupos} style={{width: '100%'}}
                                          optionLabel="nome" 
                                          filter showClear filterBy="nome"
                                          onChange={this.onChangeGrupo}
                                          id="grupoConsulta"
                                          className="p-inputtext-sm p-d-block p-mb-1"/>
                                    </div>
                                  </div>
                                </div>
                                <div className="direita">
                                  <button type="submit" className="btn btn-success" onClick={this.consultarPessoas}>
                                    <i className="fas fa-check"></i>
                                    &nbsp;Aplicar
                                  </button>
                                </div>
                                
                              </OverlayPanel>
                              &nbsp;
                              <input type="text" className="form-control" 
                                  placeholder="Consulte uma pessoa pelo nome..."
                                  value={this.state.consultaNome}
                                  onChange={e => this.setState({consultaNome: e.target.value})}
                                  onKeyPress={event => event.key === 'Enter' && this.consultaRapida()}/>
                                  <span className="input-group-prepend">
                                  <span className="input-group-text">
                                  <i className="fas fa-search"></i>
                                  </span>
                                  </span>
                            </span>
                        </div>
                      </div>
                      <br></br>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group" style={{paddingLeft: '12px'}}>
                            <a onClick={this.onA} className={this.state.letraA} style={{fontSize: '14px', cursor: 'pointer'}}>A</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onB} className={this.state.letraB} style={{fontSize: '14px', cursor: 'pointer'}}>B</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onC} className={this.state.letraC} style={{fontSize: '14px', cursor: 'pointer'}}>C</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onD} className={this.state.letraD} style={{fontSize: '14px', cursor: 'pointer'}}>D</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onE} className={this.state.letraE} style={{fontSize: '14px', cursor: 'pointer'}}>E</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onF} className={this.state.letraF} style={{fontSize: '14px', cursor: 'pointer'}}>F</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onG} className={this.state.letraG} style={{fontSize: '14px', cursor: 'pointer'}}>G</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onH} className={this.state.letraH} style={{fontSize: '14px', cursor: 'pointer'}}>H</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onI} className={this.state.letraI} style={{fontSize: '14px', cursor: 'pointer'}}>I</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onJ} className={this.state.letraJ} style={{fontSize: '14px', cursor: 'pointer'}}>J</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onK} className={this.state.letraK} style={{fontSize: '14px', cursor: 'pointer'}}>K</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onL} className={this.state.letraL} style={{fontSize: '14px', cursor: 'pointer'}}>L</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onM} className={this.state.letraM} style={{fontSize: '14px', cursor: 'pointer'}}>M</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onN} className={this.state.letraN} style={{fontSize: '14px', cursor: 'pointer'}}>N</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onO} className={this.state.letraO} style={{fontSize: '14px', cursor: 'pointer'}}>O</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onP} className={this.state.letraP} style={{fontSize: '14px', cursor: 'pointer'}}>P</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onQ} className={this.state.letraQ} style={{fontSize: '14px', cursor: 'pointer'}}>Q</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onR} className={this.state.letraR} style={{fontSize: '14px', cursor: 'pointer'}}>R</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onS} className={this.state.letraS} style={{fontSize: '14px', cursor: 'pointer'}}>S</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onT} className={this.state.letraT} style={{fontSize: '14px', cursor: 'pointer'}}>T</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onU} className={this.state.letraU} style={{fontSize: '14px', cursor: 'pointer'}}>U</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onV} className={this.state.letraV} style={{fontSize: '14px', cursor: 'pointer'}}>V</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onX} className={this.state.letraX} style={{fontSize: '14px', cursor: 'pointer'}}>X</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onZ} className={this.state.letraZ} style={{fontSize: '14px', cursor: 'pointer'}}>Z</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onY} className={this.state.letraY} style={{fontSize: '14px', cursor: 'pointer'}}>Y</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a onClick={this.onW} className={this.state.letraW} style={{fontSize: '14px', cursor: 'pointer'}}>W</a>
                          </div>
                        </div>
                      </div>

                      <ConfirmDialog visible={this.state.visible} 
                           onHide={() => this.setState({ visible: false })} 
                           message="Are you sure you want to proceed?"
                           header="Confirmation"
                           icon="pi pi-exclamation-triangle" 
                           accept={() => this.excluirPessoa} 
                           reject={() => this.setState({visible: false})}/>


                        <Backdrop
                          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                          open={this.state.openSpinner}>
                          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
                        </Backdrop>

                      <DataTable value={this.state.clientes}  paginator responsiveLayout="scroll"
                        size="small"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10} emptyMessage=" "
                        selectionMode="multiple">
                          <Column field="nome" header="Nome"></Column>
                          <Column field="tipoPessoaCalculada" header="Tipo de Pessoa"></Column>
                          <Column field="perfil.nome" header="Perfil"></Column>
                          <Column field="cidade.nome" header="Cidade"></Column>
                          <Column field="email" header="Email"></Column>
                          <Column field="telefone1" header="Telefone"></Column>
                          <Column field="grupoCliente.nome" header="Grupo"></Column>
                          <Column field="statusCalculado" header="Status"></Column>
                          <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                      </DataTable>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Dialog header="Documentos"
                visible={this.state.modalDocumentos} 
                style={{ width: '40vw' }} 
                footer={this.renderFooterDocumentos('modalDocumentos')} 
                onHide={() => this.fecharModal('modalDocumentos')}>

                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <a href={this.state.linkContratoPrestacaoServico} 
                        className="cursor" 
                        target="_blank"
                        title="Contrato de Prestação de Serviço"
                        onClick={this.documentoContratoPrestacaoServico}>
                          Contrato de Prestação de Serviço
                      </a>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <a href={this.state.linkDocumentoProcuracaoAdJudicia} 
                        className="cursor" 
                        target="_blank"
                        title="Procuração Ad Judicia"
                        onClick={this.documentoProcuracaoAdJudicia}>
                          Procução AD Judicia
                      </a>
                    </div>
                  </div>
                </div>
            </Dialog>
          </section>
        </div>
      </>
    )
  }
}

Pessoas.contextType = AuthContext;
export default withRouter(Pessoas)